var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJackPicto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71951 0.197266H10.3021V12.4831C10.3824 13.9977 9.86577 15.4834 8.86309 16.6214C8.39338 17.1368 7.81731 17.5439 7.17475 17.8146C6.53218 18.0853 5.83847 18.2132 5.1416 18.1894C4.44329 18.2287 3.74455 18.12 3.09122 17.8703C2.43789 17.6206 1.84473 17.2356 1.35065 16.7405C0.399976 15.6173 -0.0800142 14.1702 0.0109121 12.7015H3.61331C3.61331 14.3786 4.12936 15.2122 5.16145 15.2122C6.19354 15.2122 6.71951 14.2198 6.71951 12.3045V0.197266Z",
    fill: "#434A57"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackPicto);
export default __webpack_public_path__ + "static/media/jack-picto.4c64872816eceb43408144165024daf5.svg";
export { ForwardRef as ReactComponent };